import React from 'react';

import { flagStyles } from '../settings';

const SvgSR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4920px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSR;
